"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeBoclipsClient = void 0;
const FakeAttachmentsClient_1 = require("../sub-clients/attachments/client/FakeAttachmentsClient");
const FakeCartsClient_1 = require("../sub-clients/carts/client/FakeCartsClient");
const FakeCollectionsClient_1 = require("../sub-clients/collections/client/FakeCollectionsClient");
const FakeChannelsClient_1 = require("../sub-clients/channels/client/FakeChannelsClient");
const FakeContractLegalRestrictionsClient_1 = require("../sub-clients/contractLegalRestrictions/client/FakeContractLegalRestrictionsClient");
const FakeEduAgeRangesClient_1 = require("../sub-clients/educationalAgeRanges/client/FakeEduAgeRangesClient");
const FakeEventsClient_1 = require("../sub-clients/events/client/FakeEventsClient");
const FakeIngestVideoStatusesClient_1 = require("../sub-clients/ingestVideoStatuses/client/FakeIngestVideoStatusesClient");
const FakeJobsClient_1 = require("../sub-clients/jobs/client/FakeJobsClient");
const FakeLegalRestrictionsClient_1 = require("../sub-clients/legalRestrictions/client/FakeLegalRestrictionsClient");
const FakeMarketingStatusesClient_1 = require("../sub-clients/marketingStatuses/client/FakeMarketingStatusesClient");
const FakeOrdersClient_1 = require("../sub-clients/orders/client/FakeOrdersClient");
const FakeSubjectsClient_1 = require("../sub-clients/subjects/client/FakeSubjectsClient");
const FakeDisciplinesClient_1 = require("../sub-clients/disciplines/client/FakeDisciplinesClient");
const FakeVideoTypesClient_1 = require("../sub-clients/videoTypes/client/FakeVideoTypesClient");
const FakeBestForTagsClient_1 = require("../sub-clients/bestForTags/client/FakeBestForTagsClient");
const FakeIngestVideosClient_1 = require("../sub-clients/ingestVideos/client/FakeIngestVideosClient");
const FakeVideosClient_1 = require("../sub-clients/videos/client/FakeVideosClient");
const FakeSuggestionsClient_1 = require("../sub-clients/suggestions/client/FakeSuggestionsClient");
const FakeContentWarningsClient_1 = require("../sub-clients/contentWarnings/client/FakeContentWarningsClient");
const FakeContractsClient_1 = require("../sub-clients/contracts/client/FakeContractsClient");
const FakeShareLinksClient_1 = require("../sub-clients/shareLinks/client/FakeShareLinksClient");
const FakeDistributionMethodsClient_1 = require("../sub-clients/distributionMethods/client/FakeDistributionMethodsClient");
const FakeContentPackagesClient_1 = require("../sub-clients/contentPackages/client/FakeContentPackagesClient");
const FakeUsersClient_1 = require("../sub-clients/users/client/FakeUsersClient");
const AdminLinksFactory_1 = require("./AdminLinksFactory");
const FakeCategoriesClient_1 = require("../sub-clients/taxonomies/client/FakeCategoriesClient");
const FakeAccountsClient_1 = require("../sub-clients/accounts/client/FakeAccountsClient");
const FakeCustomMetadataClient_1 = __importDefault(require("../sub-clients/customMetadata/client/FakeCustomMetadataClient"));
const FakeEducationLevelsClient_1 = require("../sub-clients/educationLevels/client/FakeEducationLevelsClient");
const FakeAlignmentsClient_1 = __importDefault(require("../sub-clients/alignments/client/FakeAlignmentsClient"));
const FakeVideoAIMetadataClient_1 = __importDefault(require("../sub-clients/videoAIMetadata/client/FakeVideoAIMetadataClient"));
const FakeLicensesClient_1 = require("../sub-clients/licenses/client/FakeLicensesClient");
const FakeSchoolsClient_1 = require("../sub-clients/schools/client/FakeSchoolsClient");
const CountriesClient_1 = require("../sub-clients/countries/client/CountriesClient");
const FakeChatClient_1 = require("../sub-clients/chat/client/FakeChatClient");
const FakeDistrictsClient_1 = require("../sub-clients/districts/client/FakeDistrictsClient");
class FakeBoclipsClient {
    constructor() {
        this.adminLinks = AdminLinksFactory_1.AdminLinksFactory.sample({});
        this.getLinks = () => this.adminLinks;
        this.setLinks = (links) => {
            this.adminLinks = links;
        };
        this.links = this.getLinks();
        this.legalRestrictions = new FakeLegalRestrictionsClient_1.FakeLegalRestrictionsClient();
        this.categories = new FakeCategoriesClient_1.FakeCategoriesClient();
        this.channels = new FakeChannelsClient_1.FakeChannelsClient();
        this.contracts = new FakeContractsClient_1.FakeContractsClient();
        this.subjects = new FakeSubjectsClient_1.FakeSubjectsClient();
        this.disciplines = new FakeDisciplinesClient_1.FakeDisciplinesClient();
        this.collections = new FakeCollectionsClient_1.FakeCollectionsClient();
        this.orders = new FakeOrdersClient_1.FakeOrdersClient();
        this.events = new FakeEventsClient_1.FakeEventsClient();
        this.jobs = new FakeJobsClient_1.FakeJobsClient();
        this.videoTypes = new FakeVideoTypesClient_1.FakeVideoTypesClient();
        this.ingestVidoes = new FakeIngestVideosClient_1.FakeIngestVideosClient();
        this.bestForTags = new FakeBestForTagsClient_1.FakeBestForTagsClient();
        this.marketingStatuses = new FakeMarketingStatusesClient_1.FakeMarketingStatusesClient();
        this.eduAgeRanges = new FakeEduAgeRangesClient_1.FakeEduAgeRangesClient();
        this.ingestVideoStatuses = new FakeIngestVideoStatusesClient_1.FakeIngestVideoStatusesClient();
        this.contractLegalRestrictions = new FakeContractLegalRestrictionsClient_1.FakeContractLegalRestrictionsClient();
        this.suggestions = new FakeSuggestionsClient_1.FakeSuggestionsClient();
        this.contentWarnings = new FakeContentWarningsClient_1.FakeContentWarningsClient();
        this.shareLinks = new FakeShareLinksClient_1.FakeShareLinksClient();
        this.attachments = new FakeAttachmentsClient_1.FakeAttachmentsClient();
        this.contentPackages = new FakeContentPackagesClient_1.FakeContentPackagesClient();
        this.videos = new FakeVideosClient_1.FakeVideosClient(this.contentPackages);
        this.users = new FakeUsersClient_1.FakeUsersClient();
        this.carts = new FakeCartsClient_1.FakeCartsClient();
        this.distributionMethods = new FakeDistributionMethodsClient_1.FakeDistributionMethodsClient();
        this.accounts = new FakeAccountsClient_1.FakeAccountsClient(this.users);
        this.customMetadata = new FakeCustomMetadataClient_1.default();
        this.educationLevels = new FakeEducationLevelsClient_1.FakeEducationLevelsClient();
        this.alignments = new FakeAlignmentsClient_1.default();
        this.videoAIMetadata = new FakeVideoAIMetadataClient_1.default();
        this.licenses = new FakeLicensesClient_1.FakeLicensesClient();
        this.schools = new FakeSchoolsClient_1.FakeSchoolsClient();
        this.districts = new FakeDistrictsClient_1.FakeDistrictsClient();
        this.countries = new CountriesClient_1.CountriesClient();
        this.chat = new FakeChatClient_1.FakeChatClient();
    }
    clear() {
        this.legalRestrictions.clear();
        this.channels.clear();
        this.contracts.clear();
        this.subjects.clear();
        this.collections.clear();
        this.videos.clear();
        this.orders.clear();
        this.jobs.clear();
        this.events.clear();
        this.videoTypes.clear();
        this.ingestVidoes.clear();
        this.bestForTags.clear();
        this.eduAgeRanges.clear();
        this.marketingStatuses.clear();
        this.contractLegalRestrictions.clear();
        this.suggestions.clear();
        this.contentWarnings.clear();
        this.attachments.clear();
        this.contentPackages.clear();
        this.categories.clear();
        this.users.clear();
        this.carts.clear();
        this.distributionMethods.clear();
        this.accounts.clear();
        this.customMetadata.clear();
        this.videoAIMetadata.clear();
        this.links = AdminLinksFactory_1.AdminLinksFactory.sample({});
        this.licenses.clear();
        this.schools.clear();
        this.districts.clear();
    }
}
exports.FakeBoclipsClient = FakeBoclipsClient;
//# sourceMappingURL=FakeBoclipsClient.js.map